import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import App from "./App.js";
import ReaderPage from "./pages/ReaderPage.js"; // Import the new page
import Article from "./pages/article.js";  // ✅ Import the new article page
import FeatureMatrix from "./pages/FeatureMatrix.js"; // Import the new page


const root = createRoot(document.getElementById("root"));
root.render(
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/reader" element={<ReaderPage />} />
        <Route path="/article" element={<Article />} />  
        <Route path="/features" element={<FeatureMatrix />} />  {/* ✅ New Route */}
        <Route path="*" element={<Navigate to="/" />} />  {/* ✅ Redirect unknown routes to home */}
      </Routes>
    </Router>
  );
